import Layout from '@layout/Index'

export const platformDepartment = [
  {
    path: '/platform-department',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "PlatformDepartmentTable" */ './pages/PlatformDepartmentTable.vue'),
        name: '部门管理',
        meta: {
          title: '部门管理',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "PlatformDepartmentForm" */ './pages/PlatformDepartmentForm.vue'),
        name: '新增部门',
        meta: {
          title: '新增部门',
        },
      },
      {
        path: 'update/:departmentId',
        component: () => import(/* webpackChunkName: "PlatformDepartmentForm" */ './pages/PlatformDepartmentForm.vue'),
        name: '编辑部门',
        meta: {
          title: '编辑部门',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/platform-department/platform-department.route.js